import React from 'react'
import { Redirect, useLocation, useParams } from 'react-router-dom'

import { Loader, VendorFilterContext } from '../../components'
import { useApi } from '../../providers'
import {
  categoryLookup,
  categoryPath,
  samePath,
  vendorLookup
} from '../../routes/links'

import { NotFoundPage } from '../not-found'
import { ProductsViewPage } from '../products'

import { CategoryPage } from './category'
import {
  CategoryRouteParams,
  LegacyCategoryRouteParams
} from './category.types'

export const CategoryRoutePage = () => {
  const { slug, vendorSlug } = useParams<CategoryRouteParams>()
  const location = useLocation()
  const {
    category: { useCategory },
    vendor: { useVendor }
  } = useApi()
  const { data, loading } = useCategory(categoryLookup(slug))
  const { data: vendorData, loading: vendorLoading } = useVendor(
    vendorSlug ? vendorLookup(vendorSlug) : undefined
  )

  if (loading || vendorLoading) {
    return <Loader />
  }

  const category = data?.category
  const vendor = vendorData?.vendor

  if (!category || (vendorSlug && !vendor)) {
    return <NotFoundPage />
  }

  const pathname = categoryPath(category, vendor)

  if (!samePath(location.pathname, pathname)) {
    return <Redirect to={{ ...location, pathname }} />
  }

  if (!vendor && category.children.edges.length > 0) {
    return <CategoryPage category={category} />
  }

  return (
    <VendorFilterContext.Provider value={vendor?.id}>
      <ProductsViewPage
        key={`category_products_${category.id}_${vendor?.id}`}
        category={category}
        vendorId={vendor?.id}
      />
    </VendorFilterContext.Provider>
  )
}

export const LegacyCategoryRedirect = () => {
  const { id, vendorId } = useParams<LegacyCategoryRouteParams>()
  const vendor = vendorId ? { id: vendorId } : undefined

  return <Redirect to={categoryPath({ id }, vendor)} />
}
